<template>
    <button
        v-tippy="t('editorAddColumnBefore')"
        :class="[buttonState(editor.can().addColumnBefore()), 'flex-none rounded p-1 text-sm']"
        :disabled="!editor.can().addColumnBefore()"
        @click="editor.chain().focus().addColumnBefore().run()"
    >
        <MdiTableColumnPlusBefore class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import MdiTableColumnPlusBefore from 'materialdesignicons-vue3/icons/MdiTableColumnPlusBefore.js';

    defineExpose({
        name: 'AddTableColumnBeforeButton',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
</script>
